import config from "./config";
var axios = config();

export default {
  getExpertsSummary() {
    return axios.get("/api/ExpertsReports/summary");
  },
  getWorkloadsSummary(timePeriodId) {
    return axios.get(
      "/api/WorkloadsReports/Summary?timePeriodId=" + timePeriodId
    );
  },
  getAwardsPerYear() {
    return axios.get("/api/AwardReports/PerYear");
  },
  getAwardsCompletedPerYear() {
    return axios.get("/api/AwardReports/CompletedPerYear");
  },
  getTopCommunityPartners() {
    return axios.get("/api/communitypartnerreports/summary");
  },
  getPartnersPerYear() {
    return axios.get("/api/communitypartnerreports/PerYear");
  },
  getCommunityPartnerExport() {
    return axios.get("/api/communitypartnerreports/exportcsv");
  },
  getCoursePlan(timePeriodId) {
    return axios.get(
      "/api/WorkloadsReports/CoursePlan?timePeriodId=" + timePeriodId
    );
  }
};
